import styled from "styled-components";
import { theme } from "@themes";

export const HomeStyledContainer = styled.div`
  padding: 8px;
  background: ${({ theme }) => theme.background.tertiary};
  min-height: 100vh;
`;
